export function getDate(iso8601: string): string {
  return iso8601.split("T")[0];
}
